import React, { useState } from 'react';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import EmailSender from './EmailSender';

const EmailButton = ({ 
  recordData, 
  objectName, 
  currentUser, 
  variant = 'outline-primary',
  size = 'sm',
  className = '',
  showTooltip = true,
  onEmailSent 
}) => {
  const [showEmailModal, setShowEmailModal] = useState(false);

  const handleEmailSent = (emailData) => {
    if (onEmailSent) {
      onEmailSent(emailData);
    }
  };

  const button = (
    <Button
      variant={variant}
      size={size}
      className={`email-button ${className}`}
      onClick={() => setShowEmailModal(true)}
    >
      <i className="fas fa-envelope me-1"></i>
      Send Email
    </Button>
  );

  const tooltip = (
    <Tooltip id="email-tooltip">
      Send email to {recordData?.name || recordData?.firstname || 'this record'}
    </Tooltip>
  );

  return (
    <>
      {showTooltip ? (
        <OverlayTrigger
          placement="top"
          overlay={tooltip}
        >
          {button}
        </OverlayTrigger>
      ) : (
        button
      )}

      <EmailSender
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        recordData={recordData}
        objectName={objectName}
        onEmailSent={handleEmailSent}
        currentUser={currentUser}
      />
    </>
  );
};

export default EmailButton; 